import {
  ChangeDetectionStrategy,
  input,
  Component,
  TemplateRef,
  ViewContainerRef,
  AfterViewInit,
  OnDestroy,
  inject,
  viewChild,
} from '@angular/core';

import { LayoutService } from '@assist/shared/data';
import { TemplatePortal } from '@angular/cdk/portal';

@Component({
  selector: 'assist-layout-buttons',
  imports: [],
  templateUrl: './layout-buttons.component.html',
  styleUrls: ['./layout-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutButtonsComponent implements AfterViewInit, OnDestroy {
  private layoutService = inject(LayoutService);
  private viewContainerRef = inject(ViewContainerRef);
  // have layout service
  template = viewChild<TemplateRef<any>>(TemplateRef);

  where = input<'mobile' | 'desktop' | 'both'>('both');

  ngAfterViewInit(): void {
    this.layoutService.setButtons(new TemplatePortal(this.template(), this.viewContainerRef), this.where());
  }

  ngOnDestroy(): void {
    this.layoutService.removeButtons();
  }

  // have layout service
}
